export default __webpack_public_path__ + "static/media/vendor_stall.2755e2c7.jpg";